<template>
  <label class="UIInputLabel" :for="htmlFor">
    <slot />

    <slot name="is-required">
      <span v-if="isRequired" class="UIInputLabel__is-required"> *</span>
    </slot>
  </label>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    isRequired?: boolean
    htmlFor?: string
  }>(),
  {
    isRequired: false,
    htmlFor: undefined,
  },
)
</script>

<style scoped lang="scss">
.UIInputLabel {
  @include font-size-14px;
  font-weight: 500;
  color: $color-neutral-170;
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;

  .UIInputLabel__is-required {
    display: contents;
    color: $color-error-40;
    font-size: 0.75rem;
  }
}
</style>
